import { render, staticRenderFns } from "./cardTags.vue?vue&type=template&id=3b77e9e9"
import script from "./cardTags.vue?vue&type=script&lang=js"
export * from "./cardTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports